module.exports = __webpack_public_path__ + "img/credit-card-dent-red.4f9dd721.svg";